import { Component, Input } from '@angular/core'

import { ApiOrder, ExtraCost } from '../../../cart/models/cart-models'
import { Address } from '../../../core/models/address'
import { Setting } from '../../../core/models/setting';

import * as moment from 'moment'
import { Observable } from 'rxjs';
import { select, Store } from '@ngrx/store';
import * as fromBase from '../../../base/reducers';
import chaining from '../../../core/helpers/chaining';

@Component({
  selector: 'app-summary-page',
  templateUrl: './template.html',
  styleUrls: ['./styles.scss']
})
export class SummaryPageComponent {
  @Input() order: ApiOrder
  @Input() addresses: Address[]
  @Input() quantityPicker: String
  @Input() checkoutPageSettings: Setting
  @Input() extraCosts: ExtraCost[]

  fullWidthView$: Observable<boolean>

  constructor(private store: Store<any>) {
    this.fullWidthView$ = store
      .pipe(
        select(fromBase.isFullWidthViewEnabled)
      )
  }

  get deliveryDate(): string {
    return moment(chaining(this, 'order.dlvDate')).format('L')
  }

  get address(): Address {
    return this.addresses.find(address => address.code === chaining(this, 'order.dlvAddress'))
  }

  get currency(): string {
    return this.order.currency;
  }
}
